















import { Component, Vue, Prop } from "vue-property-decorator";
import SolicitacaoModel, { SolicitacaoDados } from "@/models/Solicitacao";
import { getModule } from "vuex-module-decorators";
import { store, UserModule } from "@/store";
import firebase from "firebase";
import { UserDb, USERS_COLLECTION } from "@/models/User";
import SolicitacoesList, { SolicitacaoComParte } from "@/components/SolicitacoesList.vue";
import _debug from "debug";

const debug = _debug("Mediacao:views:Solicitacoes.vue");

@Component({
    components: { solicitacoesList: SolicitacoesList },
})
export default class Solicitacoes extends Vue {
    public carregandoSolicitacoes = true;
    private solicitacoes: SolicitacaoComParte[] = [];

    public pegarSolicitacao(solicitacao: SolicitacaoComParte) {
        debug("Pegando solicitção para criar um novo processo...", solicitacao);
        this.$router.push(`/processo/novo/${solicitacao.id}`);
    }

    private created() {
        this.carregandoSolicitacoes = true;
        this.fetchSolicitacoes();
        setTimeout(() => {
            this.carregandoSolicitacoes = false;
        }, 2000);
    }

    private async fetchSolicitacoes() {
        firebase
            .firestore()
            .collection("solicitacoes")
            .onSnapshot(
                snapshot => {
                    snapshot.forEach(async doc => {
                        const data = Object.assign(doc.data(), { id: doc.id });
                        this.fetchRefsAndAdd(data as SolicitacaoDados);
                    });
                },
                error => {
                    console.warn("Erro escutando coleção de solicitações", error);
                },
            );
    }

    private async fetchRefsAndAdd(solicitacao: SolicitacaoDados) {
        if (solicitacao.userParteUm) {
            let parteRef: any = solicitacao.userParteUm;
            if (typeof parteRef === "string") {
                parteRef = await firebase
                    .firestore()
                    .collection(USERS_COLLECTION)
                    .doc(solicitacao.userParteUm)
                    .get();
            } else {
                parteRef = await parteRef.get();
            }

            const parte = parteRef.data();
            const solicitacaoCompleta: any = Object.assign({}, solicitacao as unknown, { parte });
            if (!this.solicitacoes.includes(solicitacaoCompleta)) {
                this.solicitacoes.push(solicitacaoCompleta);
                this.carregandoSolicitacoes = false;
            }
        } else {
            console.warn("Recebeu solicitação sem parte!", solicitacao);
        }
    }
}
